import React from 'react';
import { theme } from '../../../style/global-style';
import { StyledIconWrapper, StyledListItem, StyledWrapper } from './icon-list.style';

interface IProps {
    labels: string[];
    color?: string;
    icon?: React.ReactElement;
}

export const IconList = (props: IProps) => {
    const { labels, icon, color } = props;

    return (
        <StyledWrapper color={color} data-testid="icon-list-wrapper">
            {!!labels?.length &&
                labels.map((label, index) => (
                    <StyledListItem
                        data-testid="icon-list-item"
                        key={label.replace(/ /g, '').substr(0, 5) + index}
                    >
                        <StyledIconWrapper>{icon}</StyledIconWrapper>
                        <span>{label}</span>
                    </StyledListItem>
                ))}
        </StyledWrapper>
    );
};

IconList.defaultProps = {
    color: theme.colors.black,
};
